import React, { useEffect, useState } from 'react'
import { isLexusCss } from 'utils/utils'

type Props = {
  cssProps?: string
  name?: string
  title?: string
  detail?: string
  headingLevel?: 1 | 2 | 3 | 4 | 5 | 6
}

const HeadingParagraph: React.FC<Props> = ({
  cssProps,
  name,
  title,
  detail,
  headingLevel = 3,
}) => {
  const [fontClass, setFontClass] = useState('')

  useEffect(() => {
    const url = window.location.href
    isLexusCss(url).then(css => {
      if (css && css[0]) {
        setFontClass(css[0])
      }
    })
  }, [])

  const HeadingTag = `h${headingLevel}` as keyof JSX.IntrinsicElements

  const titleClass = `remove-empty-content font-${fontClass}`

  const paragraphClass =
    cssProps && cssProps.includes('bold')
      ? fontClass?.includes('Lexus')
        ? 'remove-empty-content pb-4 font-LexusTypeBold'
        : 'remove-empty-content pb-4 font-ToyotaTypeBold'
      : `remove-empty-content pb-4 font-${fontClass}`

  return (
    <>
      <HeadingTag className={titleClass}>
        {title}
      </HeadingTag>

      <p className={paragraphClass}>
        {name}
        {detail && (
          <>
            <br />
            {detail}
          </>
        )}
      </p>
    </>
  )
}

export default HeadingParagraph
